import React from 'react'
import './tabbedFilter.less'

export type FilterTab = {
  isSelected: boolean
  content: string
  id: string
}

export interface TabbedFilterProps {
  tabs: FilterTab[]
  className?: string | number | boolean | React.ReactElement
  onClick: (id: string) => void
}

const TabbedFilter = (props: TabbedFilterProps): React.ReactElement => {
  const { tabs, className, onClick } = props

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const clickedElement = event.target as HTMLElement
    if (clickedElement.classList.contains('btn')) {
      onClick(clickedElement.getAttribute('data-id') as string)
    }
  }

  return (
    <div
      className={`tabbed-filter ${className || ''} button-style`}
      onClick={handleClick}
      data-test-id="tabbed-filter"
    >
      {tabs.map((tab, i) => {
        return (
          <button
            key={i}
            className={`ui secondary button step-tab ${tab.isSelected ? 'selected' : ''}`}
            type="button"
            data-id={tab.id}
          >
            {tab.content}
          </button>
        )
      })}
    </div>
  )
}

export default TabbedFilter
